import script from "./TaxInvoiceRequestPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxInvoiceRequestPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TaxInvoiceRequestPanel.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__